/* Components */
import Vue from 'vue'
import Breadcrumb from './breadcrumb'
import Markdown from './markdown'
Vue.component(Breadcrumb.name, Breadcrumb)
Vue.component(Markdown.name, Markdown)